import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { canCreateAgency, canRemoveAgency, canUpdateAgency, createAgency, removeAgency, updateAgency, useOutsideAgencies } from "../../reducers/outsideAgencySlice";
import DataTable from "../../common/components/DataTable";
import useCredentials from "../../common/hooks/credentialsHook";
import useNetwork from "../../common/hooks/networkHook";
import { SettingsDisplay } from "../../common/components/SettingsPanels";
import PropTypes from 'prop-types';

const defaultSort = ['displayid']

const OutsideAgencies = ({ uuid, label, onClose }) => {
    const { t } = useTranslation();
    const agencies = useOutsideAgencies();
    const network = useNetwork();
    const credentials = useCredentials();
    const tableDef = useMemo(() => [
        { title: t('callsign'), field: 'displayid', type: 'text', editable: true },
        { title: t('mobile'), field: 'mobile', type: 'phone', maxlength: 10, editable: true }
    ], [t]);
    
    const canCreate = canCreateAgency(credentials);
    const canUpdate = canUpdateAgency(credentials);
    const canRemove = canRemoveAgency(credentials);

    return <SettingsDisplay uuid={uuid} title={label} onClose={onClose}>
        <DataTable value={agencies} columns={tableDef} showFilter={true} defaultSort={defaultSort} disabled={!canUpdate} disableRemove={!canRemove} disableAdd={!canCreate}
            onAdd={agency => createAgency(network, agency)} onUpdate={(agency, field, value) => updateAgency(network, { callsign: agency.callsign, [field]: value })}
            onRemove={agency => removeAgency(network, agency)}></DataTable>
    </SettingsDisplay>
}
OutsideAgencies.propTypes = {
    /**
     * ID to identify the settings status entry
     */
    uuid: PropTypes.string.isRequired,
    /**
     * Label for the screen
     */
    label: PropTypes.string.isRequired,
    /**
     * Function to call when the screen is closed
     */
    onClose: PropTypes.func
}

export default OutsideAgencies;